import { SVGProps } from "react";

export default function ChevronUp(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="currentColor"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g clipPath="url(#clip0_1519_23710)">
        <path d="M11.2897 8.71047L6.69973 13.3005C6.30973 13.6905 6.30973 14.3205 6.69973 14.7105C7.08973 15.1005 7.71973 15.1005 8.10973 14.7105L11.9997 10.8305L15.8797 14.7105C16.2697 15.1005 16.8997 15.1005 17.2897 14.7105C17.6797 14.3205 17.6797 13.6905 17.2897 13.3005L12.6997 8.71047C12.3197 8.32047 11.6797 8.32047 11.2897 8.71047Z" />
      </g>
      <defs>
        <clipPath id="clip0_1519_23710">
          <rect width="24" height="24" />
        </clipPath>
      </defs>
    </svg>
  );
}
